// Google Maps deep links from a plain location string (REQ-CAL-013). No API key, no Places billing:
// the "Find on map" action opens a Maps search so a member can look the place up, and "Navigate"
// opens turn-by-turn directions to it. Pure — the caller does the window.open at click time so a
// user's location text only ever leaves the app on their own tap.
const MAPS = "https://www.google.com/maps";

/** A Maps search for `location` (helps a member find/confirm the place). Empty → the Maps home. */
export function mapsSearchUrl(location: string): string {
  const q = location.trim();
  return q ? `${MAPS}/search/?api=1&query=${encodeURIComponent(q)}` : MAPS;
}

/** Turn-by-turn directions to `destination`. Empty → null (nothing to navigate to). */
export function mapsDirectionsUrl(destination: string): string | null {
  const d = destination.trim();
  return d ? `${MAPS}/dir/?api=1&destination=${encodeURIComponent(d)}` : null;
}
